import finContest from './modules/finContest';
import fkc from './modules/fkc';
import inviteMange from './modules/inviteMange';

/** 预定义路由，权限路由匹配后再注册所需路由 */
export default [
  fkc,
  inviteMange,
  finContest,
  {
    name: '中金所杯',
    path: '/cffe',
    redirect: '/cffe/admin',
    component: () => import('@/views/layout/index.vue'),
    children: [
      {
        name: '管理员菜单',
        path: '/cffe/admin',
        redirect: '/fkc/admin/signup',
        children: [
          {
            name: '报名信息查询',
            path: '/cffe/admin/signup',
            component: () => import('@/views/cffe/admin/signup/index.vue'),
          },
          {
            name: '期货模拟交易信息查询',
            path: '/cffe/admin/trade',
            component: () => import('@/views/cffe/admin/trade/index.vue'),
          },
          {
            name: '知识答题信息查询',
            path: '/cffe/admin/knowledge',
            component: () => import('@/views/cffe/admin/knowledge/index.vue'),
          },
          {
            name: '复赛名单查询',
            path: '/cffe/admin/final',
            component: () => import('@/views/cffe/admin/final/index.vue'),
          },
          {
            name: '获奖名单查询',
            path: '/cffe/admin/award',
            component: () => import('@/views/cffe/admin/award/index.vue'),
          },
          {
            name: '复赛成绩查询',
            path: '/cffe/admin/grade',
            component: () => import('@/views/cffe/admin/grade/index.vue'),
          },
        ],
      },
      {
        name: '领队菜单',
        path: '/cffe/leader',
        redirect: '/cffe/leader/signup',
        children: [
          {
            name: '报名信息查询',
            path: '/cffe/leader/signup',
            component: () => import('@/views/cffe/leader/signup/index.vue'),
          },
          {
            name: '期货模拟交易信息查询',
            path: '/cffe/leader/trade',
            component: () => import('@/views/cffe/leader/trade/index.vue'),
          },
          {
            name: '知识答题信息查询',
            path: '/cffe/leader/knowledge',
            component: () => import('@/views/cffe/leader/knowledge/index.vue'),
          },
          {
            name: '复赛名单查询',
            path: '/cffe/leader/final',
            component: () => import('@/views/cffe/leader/final/index.vue'),
          },

          {
            name: '复赛结果查询',
            path: '/cffe/leader/result',
            component: () => import('@/views/cffe/leader/result/index.vue'),
          },
          {
            name: '证书下载',
            path: '/cffe/leader/certificate',
            component: () => import('@/views/cffe/leader/certificate/index.vue'),
          },
        ],
      },
      {
        name: '证件管理',
        path: '/cffe/certificate',
        redirect: '/cffe/certificate/list',
        children: [
          {
            name: '证件列表',
            path: '/cffe/certificate/list',
            component: () => import('@/views/cffe/certificate/list/index.vue'),
          },
        ],
      },
    ],
  },
  {
    name: '系统管理',
    path: '/system',
    redirect: '/system/auth',
    // component: () => import('@/views/layout/router-view.vue'),
    children: [
      {
        name: '权限管理',
        path: '/system/auth',
        redirect: '/system/auth/menu',
        component: () => import('@/views/layout/index.vue'),
        meta: {
          icon: 'el-icon-eleme',
        },
        children: [
          {
            name: '角色管理',
            path: '/system/auth/role',
            component: () => import('@/views/role/index.vue'),
          },
          {
            name: '用户管理',
            path: '/system/auth/user',
            component: () => import('@/views/user/index.vue'),
          },
          {
            name: '菜单管理',
            path: '/system/auth/menu',
            component: () => import('@/views/menu-manage/index.vue'),
          },
          // {
          //   name: '此路由的父级路由在菜单中，但是菜单页面，不会注册到路由中',
          //   path: '/system/pages1/page1/detail',
          //   component: () => import('@/views/operational-config/enum-config/enum-type-config/index.vue'),
          // },
          // {
          //   name: '此路由的父级路由在菜单中，将注册到路由中',
          //   path: '/system/pages1/page1/detail',
          //   component: () => import('@/views/system1/page1/detail1.vue'),
          //   notMenu: true,
          // },
          // {
          //   name: '此路由的父级路由不再菜单中，不会注册到路由中',
          //   path: '/system/pages1/page1/name/detail',
          //   component: () => import('@/views/system1/page1/detail2.vue'),
          //   notMenu: true,
          // },
        ],
      },
      {
        name: '领队菜单',
        path: '/system/leader',
        component: () => import('@/views/layout/index.vue'),
        redirect: '/system/leader/ActiveLeaders',
        children: [
          {
            name: '已开通领队权限',
            path: '/system/leader/ActiveLeaders',
            component: () => import('@/views/LeaderManagement/ActiveLeaders/index.vue'),
          },
          {
            name: '已删除领队权限',
            path: '/system/leader/DeletedLeaders',
            component: () => import('@/views/LeaderManagement/DeletedLeaders/index.vue'),
          },
        ],
      },
    ],
  },
  {
    name: '证书中心配置',
    path: '/cert',
    redirect: '/cert/cert-manage',
    component: () => import('@/views/layout/index.vue'),
    children: [
      {
        name: '证书配置',
        path: '/cert/cert-manage',
        component: () => import('@/views/cert/cert-manage/index.vue'),
      },
      {
        name: '证书字段配置',
        path: '/cert/params-manage',
        component: () => import('@/views/cert/params-manage/index.vue'),
      },
      {
        name: '发布配置',
        path: '/cert/publish-manage',
        component: () => import('@/views/cert/publish-manage/index.vue'),
      },
    ],
  },
  {
    name: '大赛素材',
    path: '/rich',
    redirect: '/rich/rich-group',
    component: () => import('@/views/layout/index.vue'),
    children: [
      {
        name: '富文本分组',
        path: '/rich/rich-group',
        component: () => import('@/views/rich-group/index.vue'),
      },
      {
        name: '富文本配置',
        path: '/rich/rich-config',
        component: () => import('@/views/rich-config/index.vue'),
      },
      {
        name: '素材分组',
        path: '/material/material-group',
        component: () => import('@/views/material-group/index.vue'),
      },
      {
        name: '素材管理',
        path: '/material/material-manage',
        component: () => import('@/views/material-manage/index.vue'),
      },
    ],
  },
  {
    name: '赛事管理',
    path: '/comp',
    redirect: '/comp/compConfig',
    component: () => import('@/views/layout/index.vue'),
    children: [
      {
        name: '赛事配置',
        path: '/comp/compConfig',
        component: () => import('@/views/compConfig/index.vue'),
      },
      {
        name: '赛项配置',
        path: '/comp/race-config',
        component: () => import('@/views/race-config/index.vue'),
      },
      {
        name: '组织配置',
        path: '/comp/org-manage',
        component: () => import('@/views/org-manage/index.vue'),
      },
      {
        name: '模拟交易渠道监控',
        path: '/comp/simTrade-monitor',
        component: () => import('@/views/simTrade-monitor/index.vue'),
      },
    ],
  },
  {
    name: '自建模拟比赛',
    path: '/self-build',
    redirect: '/self-build/comp-org-manage',
    component: () => import('@/views/layout/index.vue'),
    children: [
      {
        name: '比赛组织管理',
        path: '/self-build/comp-org-manage',
        component: () => import('@/views/self-build/comp-org-manage/index.vue'),
      },
      {
        name: '比赛管理',
        path: '/self-build/comp-manage',
        component: () => import('@/views/self-build/comp-manage/index.vue'),
      },
      {
        name: '社会组参赛信息管理',
        path: '/self-build/social-info-manage',
        component: () => import('@/views/self-build/social-info-manage/index.vue'),
      },
    ],
  },
  {
    name: '自建模拟比赛(新)',
    path: '/self-build-new',
    redirect: '/self-build-new/super',
    component: () => import('@/views/layout/index.vue'),
    children: [
      {
        name: '超级管理员菜单',
        path: '/self-build-new/super',
        redirect: '/self-build-new/super/comp-org-manage',
        children: [
          {
            name: '比赛组织管理',
            path: '/self-build-new/super/comp-org-manage',
            component: () => import('@/views/self-build-new/super/comp-org-manage/index.vue'),
          },
          {
            name: '比赛管理',
            path: '/self-build-new/super/comp-manage',
            component: () => import('@/views/self-build-new/super/comp-manage/index.vue'),
          },
          {
            name: '社会组参赛信息管理',
            path: '/self-build-new/super/social-info-manage',
            component: () => import('@/views/self-build-new/super/social-info-manage/index.vue'),
          },
          {
            name: '高校组参赛信息管理',
            path: '/self-build-new/super/school-info-manage',
            component: () => import('@/views/self-build-new/super/school-info-manage/index.vue'),
          },
          {
            name: '话术交流管理',
            path: '/self-build-new/super/exchange-manage',
            component: () => import('@/views/self-build-new/super/exchange-manage/index.vue'),
          },
          {
            name: '奖项确认管理',
            path: '/self-build-new/super/award-manage',
            component: () => import('@/views/self-build-new/super/award-manage/index.vue'),
          },
          {
            name: '获奖学生名单',
            path: '/self-build-new/super/student-list',
            component: () => import('@/views/self-build-new/super/student-list/index.vue'),
          },
        ],
      },
      {
        name: '领队菜单',
        path: '/self-build-new/leader',
        children: [
          {
            name: '当前比赛查询',
            path: '/self-build-new/leader/current-race',
            component: () => import('@/views/self-build-new/leader/current-race/index.vue'),
          },
          {
            name: '历史比赛查询',
            path: '/self-build-new/leader/history-race',
            component: () => import('@/views/self-build-new/leader/history-race/index.vue'),
          },
          {
            name: '获奖学生名单',
            path: '/self-build-new/leader/student-list',
            component: () => import('@/views/self-build-new/leader/student-list/index.vue'),
          },
        ],
      },
    ],
  },
  {
    name: '研究报告',
    path: '/research-report',
    redirect: '/research-report/admin',
    component: () => import('@/views/layout/index.vue'),
    children: [
      {
        name: '管理员菜单',
        path: '/research-report/admin',
        redirect: '/research-report/admin/prelimReportInfo',
        children: [
          {
            name: '初赛专家信息',
            path: '/research-report/admin/prelimExpertInfo',
            component: () => import('@/views/research-report/admin/ExpertInfo/prelimExpertInfo/index.vue'),
          },
          {
            name: '初赛报告信息',
            path: '/research-report/admin/prelimReportInfo',
            component: () => import('@/views/research-report/admin/ReportInfo/prelimReportInfo/index.vue'),
          },
          {
            name: '复赛专家信息',
            path: '/research-report/admin/rematchExpertInfo',
            component: () => import('@/views/research-report/admin/ExpertInfo/rematchExpertInfo/index.vue'),
          },
          {
            name: '复赛报告信息',
            path: '/research-report/admin/rematchReportInfo',
            component: () => import('@/views/research-report/admin/ReportInfo/rematchReportInfo/index.vue'),
          },
        ],
      },
      {
        name: '专家菜单',
        path: '/research-report/expert',
        redirect: '/research-report/expert/prelimReportReview',
        children: [
          {
            name: '初赛报告评审',
            path: '/research-report/expert/prelimReportReview',
            component: () => import('@/views/research-report/expert/prelimReportReview/index.vue'),
          },
          {
            name: '复赛报告评审',
            path: '/research-report/expert/rematchReportReview',
            component: () => import('@/views/research-report/expert/rematchReportReview/index.vue'),
          },
        ],
      },
      {
        name: '领队菜单',
        path: '/research-report/leader',
        redirect: '/research-report/leader/studentReportInfo',
        children: [
          {
            name: '学生报告信息',
            path: '/research-report/leader/studentReportInfo',
            component: () => import('@/views/research-report/leader/studentReportInfo/index.vue'),
          },
        ],
      },
    ],
  },
  {
    name: '赛事专区',
    path: '/comp-zone',
    redirect: '/comp-zone/comp-list',
    component: () => import('@/views/layout/index.vue'),
    children: [
      {
        name: '赛事列表',
        path: '/comp-zone/comp-list',
        component: () => import('@/views/comp-zone/comp-list/index.vue'),
      },
      {
        name: '首页素材',
        path: '/comp-zone/material-list',
        redirect: '/comp-zone/material-list/notice-bar',
        children: [
          {
            name: '跑马灯',
            path: '/comp-zone/material-list/notice-bar',
            component: () => import('@/views/comp-zone/material-list/notice-bar/index.vue'),
          },
          {
            name: '顶通Banner',
            path: '/comp-zone/material-list/top-banner',
            component: () => import('@/views/comp-zone/material-list/top-banner/index.vue'),
          },
        ],
      },
      {
        name: '赛事运营位',
        path: '/comp-zone/comp-operation',
        component: () => import('@/views/comp-zone/comp-operation/index.vue'),
      },
      {
        name: '赛事圈子',
        path: '/comp-zone/circle-list',
        component: () => import('@/views/comp-zone/circle-list/index.vue'),
      },
      {
        name: '福利专区',
        path: '/comp-zone/welfare-zone',
        component: () => import('@/views/comp-zone/welfare-zone/index.vue'),
      },
    ],
  },
];
